import React from 'react';
import { Form, FormGroup, Label, Input, Button, Row, Col, Modal, ButtonToolbar } from 'reactstrap';
import Select from 'react-select';
import API from '../../../Common/api';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import uploadIcon from '../../../../images/uploadNewIcon.svg';
import "./styles.css";

const urlParams = new URLSearchParams(window.location.search);
const paramValue = urlParams.get('id');
const paramItemCode = urlParams.get('item_code');


class HorizontalForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            employeeCode: '',
            failedModal: false,
            modalNew: false,
            fullName: '',
            email: '',
            mobile: '',
            city: '',
            role: null,
            tax_type: "",
            dataHistory: [],
            tax_community: "",
            inventoryOwner: null,
            dropDownData: [],
            warehouses: [],
            warehouses_val: [],
            availableRoles: [],
            taxType: [],
            availableOwners: [],
            taxCommunity: [],
            username_val: '',
            password: '',
            errors: {},
            itemDetails: [],
            productAttributes: [],
            productPricing: [],
            uomDetails: [],
            isAccordionOpen: true,
            sectionStatus: {
                itemDetails: false,
                productAttributes: false,
                pricingDetails: false,
                uomDetails: false
            }
        };
    }

    Failedtoggle = () => {
        this.setState((prevState) => ({ failedModal: !prevState.failedModal }));
    }

    toggleNew = () => {
        this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
    }

    toggleBack = () => {
        window.location.href = "/upload/item_master";  
    }

    editItem = ()=>{
        window.location.href = '/upload/update_items_details?id='+paramValue+'&item_code='+paramItemCode;
    }

    /*handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value, errors: { ...this.state.errors, [name]: '' } });
    };*/
    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState(
            { [name]: value, errors: { ...this.state.errors, [name]: '' } },
            () => {
                this.setState({
                    sectionStatus: {
                        itemDetails: this.isSectionComplete('itemDetails'),
                        productAttributes: this.isSectionComplete('productAttributes'),
                        pricingDetails: this.isSectionComplete('pricingDetails'),
                        uomDetails: this.isSectionComplete('uomDetails'),
                    }
                });
            }
        );
    };
    isSectionComplete = (section) => {
        switch (section) {
            case 'itemDetails':
                return (
                    this.state.item_code &&
                    this.state.item_name &&
                    this.state.item_type &&
                    this.state.item_category &&
                    this.state.sub_category &&
                    this.state.brand &&
                    this.state.sub_brand &&
                    this.state.hsn_code &&
                    this.state.hht_item_desc
                );
            case 'productAttributes':
                return (
                    this.state.ean &&
                    this.state.upc &&
                    this.state.ean_each_length &&
                    this.state.ean_each_breadth &&
                    this.state.ean_each_height 
                );
            case 'pricingDetails':
                return (
                    this.state.mrp &&
                    this.state.std_cost &&
                    this.state.per_qty
                );
            case 'uomDetails':
                return (
                    this.state.purchase_uom &&
                    this.state.std_purchase_price &&
                    this.state.sales_uom
                );
            default:
                return false;
        }
    };

    componentDidMount() {
        this.getDropDownData();
        this.fetchBinData();
         const accordion = document.getElementById("create_item_accordian");
         const accordion_buttons = document.getElementsByClassName("accordion__button");
         const accordion_items = document.getElementsByClassName("accordion__item");
         const accordion__panel = document.getElementsByClassName("accordion__panel");

        if (accordion) {
            accordion.style.setProperty("width", "92%", "important");
            accordion.style.setProperty("border", "0px", "important");
        }


        if (accordion_buttons.length > 0) {  // Check if elements exist
            for (let button of accordion_buttons) {
                button.style.setProperty("background-color", "#fff", "important");
                button.style.setProperty("font-weight", "bold", "important");
            }

        }

        if (accordion_items.length > 0) {  // Check if elements exist
            for (let button of accordion_items) {
                button.style.setProperty("margin-bottom", "10px", "important");
                button.style.setProperty("border", "0px", "important");
                
            }

        }

         if (accordion__panel.length > 0) {  // Check if elements exist
            for (let button of accordion__panel) {
                button.style.setProperty("background-color", "#fff", "important");
                
                
            }

        }
    }

    fetchBinData(page = 1){
      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
        loading_overlay:true
      })

      const url = `/tax/v1/item-list/product/${paramValue}`;
      API.get(url)
      /*callapiobj.get('/tax/v1/item-list/product/', { param: payload })*/

      .then(response => response.data)

      .then(data => {

         console.log("Area Data",data);

         this.setState({
            itemDetails: data.data.item_details,
            productAttributes: data.data.product_attributes,
            productPricing: data.data.product_pricing,
            uomDetails: data.data.uom_details,
            dataHistory: data.data.data_history,
         })

      })

      .then(async() => {

         /*this.setState({ tableRows:this.assemblePosts(), loading_overlay:false })

         console.log(this.state.tableRows);*/

      });
    }

    handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            console.log("File selected:", file.name);
            // You can update state or handle file upload here
        }
    };

    getDropDownData = () => {
        API.get('/tax/v1/item-list/product/dropdown/')
            .then((response) => response.data)
            .then((data) => {
                
                this.setState({
                    dropDownData: data.data
                })
            })
            .catch((error) => console.error(error));
    };

    createItem = () => {
        console.log(this.state.tax_community)
        this.setState({
            loading: true
        })
        const payload = {
            item_details : {
                "lb_sku_product_name": this.state.item_name,
                "product_type": 0,
                "category": this.state.item_category,
                "sub_category": this.state.sub_category,
                "sub_division": this.state.division,
                "brand": this.state.brand,
                "sub_brand": this.state.sub_brand,
                "base_pack_code": this.state.basepack,
                "status": "1",
                "hsn_code": this.state.hsn_code,
                "item_description": this.state.hht_item_desc
            },
            product_attributes: {
               "ean": this.state.ean,
               "sku":this.state.item_code,
               "ean_each": {
                   "length": this.state.ean_each_length,
                   "breadth": this.state.ean_each_breadth,
                   "height": this.state.ean_each_height
               },
               "ean_cases": {
                   "length": 0.0,
                   "breadth": 0.0,
                   "height": 0.0
               },
               "upc": 12,
               
            },
            product_pricing: {
               "mrp": this.state.mrp,
               "std_cost": this.state.std_cost,
               "per_qty": this.state.per_qty
            },
           uom_details: {
               "purchase_uom": this.state.purchase_uom,
               "std_purchase_price": this.state.std_purchase_price,
               "sales_uom": this.state.sales_uom
           }

        };

        API.post('/tax/v1/item-list/product/', { param: payload })
            .then((response) => response.data)
            .then((data) => {
                console.log(data)

                if(data.status == "success"){
                   this.setState({
                    success_message: data.message,
                    modalNew: true,
                    loading: false
                }); 
                }else{
                    this.setState({
                        failed_message: data.message,
                        failedModal: true,
                        loading: false
                    });
                }

                /*this.setState({
                    success_message: data[0].message,
                    username_val: data[0].username,
                    password: data[0].password,
                    modalNew: true,
                });*/

            })
           .catch((error) => {
              console.log(error.response.data.message)
                if (error.response.status == "400") {
                    this.setState({
                        failed_message: error.response.data.message,
                        failedModal: true,
                    });
                } else {
                    console.log(error);
                }
            });
    }
      handleAccordionToggle = (isOpen) => {
        this.setState({ isAccordionOpen: isOpen });
    };

    render() {
        const { errors, modalNew, failedModal, dropDownData, itemDetails, productAttributes, uomDetails, productPricing, dataHistory } = this.state;
        console.log()
        const isActive = itemDetails.status == 3;


        return (
            <div id="createItem_container" style={{ width: '100%', margin: '1%' }}>
                {/*<div className="statusStyle" >
                    <span  className="dotStyle"></span>
                    <span style={{ color: isActive ? 'green' : 'red', fontWeight: 'bold' }}>
                        {isActive ? 'Active' : 'Inactive'}
                    </span>
                </div>*/}
                <div className="status-container">
                    <div className="status-left">
                        <span style={{marginRight: 8, color: '#777777', fontWeight: 'bold'}}> Item Status </span>
                        <span className={`status-dot ${itemDetails.status == "Active" ? 'status-dot-active' : itemDetails.status == "Missing Information" ? 'status-dot-inactive' : 'status-dot-pending'}`}></span>
                        <span>
                            {itemDetails.status}
                        </span>
                    </div>
                    <button onClick={this.editItem} className="edit-button">
                       <i className="fa fa-edit edit-icon" aria-hidden="true"></i> Edit Rule
                    </button>
                </div>
                
                    <Accordion 
                        id="create_item_accordian" 
                       style={{ width: '100%', maxWidth: '100vw' }} 
                        allowMultipleExpanded 
                        allowZeroExpanded
                        preExpanded={['itemDetails', 'pricingDetails', 'uomDetails']}
                        onChange={(expandedItems) => this.handleAccordionToggle(expandedItems.length > 0)}
                    >
                        {/* Section 1 */}
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Item Details</span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">Item Code <span style={{ color: "red" }}>*</span></Label>
                                            <Input
                                                disabled
                                                type="text"
                                                name="item_code"
                                                value={itemDetails.sku7_code}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Item Name <span style={{ color: "red" }}>*</span></Label>
                                            <Input
                                                
                                                type="text"
                                                name="item_name"
                                                value={itemDetails.lb_sku_product_name}
                                                disabled
                                                
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Item Type <span style={{ color: "red" }}>*</span></Label>
                                            <Input
                                                
                                                type="text"
                                                className="form_text_style"
                                                value={itemDetails.item_type}
                                                disabled
                                                
                                            />
                                        </FormGroup>
                                    </Col>

                                </Row>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">Item Category <span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                name="item_category"
                                                className="form-control"
                                                value={this.state.item_category}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                                disabled
                                            >
                                                <option value="">{itemDetails.category}</option>
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Sub Category <span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                name="sub_category"
                                                className="form-control"
                                                value={this.state.sub_category}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                                disabled
                                            >
                                                <option value="">{itemDetails.sub_category}</option>
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Division</Label>
                                             <select
                                                name="division"
                                                className="form-control"
                                                value={this.state.division}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                                disabled
                                            >
                                                <option value="">{itemDetails.sub_division}</option>
                                            </select>
                                        </FormGroup>
                                    </Col>

                                </Row>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">Brand <span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                name="brand"
                                                className="form-control"
                                                value={this.state.brand}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                                disabled
                                            >
                                                <option value="">{itemDetails.brand}</option>
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Sub Brand <span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                name="sub_brand"
                                                className="form-control"
                                                value={this.state.sub_brand}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                                disabled
                                            >
                                                <option value="">{itemDetails.sub_brand}</option>
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Basepack</Label>
                                             <Input
                                                type="text"
                                                name="basepack"
                                                value={itemDetails.base_pack_code}
                                                disabled
                                            />

                                            {/*<select
                                                name="tax_type"
                                                className="form-control"
                                                value={this.state.tax_type}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select Type</option>
                                                {this.state.taxType.map((item) => (
                                                    <option key={item.value} value={item.value}>{item.label}</option>
                                                ))}
                                            </select>*/}
                                        </FormGroup>
                                    </Col>

                                </Row>

                                 <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">HSN Code<span style={{ color: "red" }}>*</span></Label>
                                            <Input
                                                type="text"
                                                name="hsn_code"
                                                value={itemDetails.hsn_code}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={8}>
                                        <FormGroup>
                                            <Label for="city">HHT Item Description<span style={{ color: "red" }}>*</span></Label>
                                             <Input
                                                type="text"
                                                name="hht_item_desc"
                                                value={itemDetails.item_description}
                                                disabled
                                            
                                            />
                                        </FormGroup>
                                    </Col>
                                    

                                </Row>

                                <Row form>
                                    <Col md={4} style={{border: '1px solid', borderColor: '#AAAAAA33', padding: '10px'}} className="d-flex justify-content-center">
                                        <div 
                                            style={{
                                                border: "2px dashed orange",
                                                backgroundColor: "#FFF3CD",
                                                padding: "20px",
                                                textAlign: "center",
                                                width: "50%",
                                                borderRadius: "8px",
                                                cursor: "pointer"
                                            }}
                                            onClick={() => document.getElementById("fileUpload").click()}
                                        >
                                            <input
                                                type="file"
                                                id="fileUpload"
                                                style={{ display: "none" }}
                                                onChange={this.handleFileUpload}
                                                accept="image/*"
                                            />
                                             <img
                                                src={uploadIcon}
                                                alt="upload"
                                                style={{ width: '25px',  }} // Adjust size as needed
                                            />
                                            <p style={{ margin: "10px 0", color: "#000" }}>Upload Item Image</p>
                                        </div>
                                    </Col>
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>

                        {/* Section 2 */}
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Product Attributes</span>
                                    
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="email">Ean</Label>
                                            <Input
                                                type="text"
                                                name="ean"
                                                id="email"
                                                onChange={this.handleChange}
                                                value={productAttributes.ean}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">UPC</Label>
                                            <Input
                                                type="text"
                                                name="ean"
                                                id="email"
                                                onChange={this.handleChange}
                                                value={productAttributes.upc}
                                                disabled
                                            />
                                            {/* <select
                                                name="upc"
                                                className="form-control"
                                                value={this.state.upc}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select Type</option>
                                                <option value={dropDownData.item_type}>{dropDownData.item_type}</option>

                                                {this.state.taxType.map((item) => (
                                                    <option key={item.value} value={item.value}>{item.label}</option>
                                                ))}
                                            </select>*/}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row form>
                                    <span style={{fontSize: 15, fontWeight: 'bold', color: 'black', width: '100%', marginBottom: 4}}> EAN Each</span>
                                    <Col md={4}>
                                        
                                        <FormGroup>
                                            <Label for="mobile">Length</Label>
                                            <Input
                                                type="number"
                                                name="ean_each_length"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={productAttributes.ean_each ? productAttributes['ean_each']['length']: ""}
                                                disabled

                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Breadth</Label>
                                            <Input
                                                type="number"
                                                name="ean_each_breadth"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={productAttributes.ean_each ? productAttributes['ean_each']['breadth']: ""}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                     <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Height</Label>
                                            <Input
                                                type="number"
                                                name="ean_each_height"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={productAttributes.ean_each ? productAttributes['ean_each']['height']: ""}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                

                                 <Row form>
                                    <span style={{fontSize: 15, fontWeight: 'bold', color: 'black', width: '100%', marginBottom: 4}}> EAN Cases</span>
                                    <Col md={4}>
                                        
                                        <FormGroup>
                                            <Label for="mobile">Length</Label>
                                            <Input
                                                type="text"
                                                name="ean_cases_length"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={productAttributes.ean_cases ? productAttributes['ean_cases']['inner_length']: ""}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Breadth</Label>
                                            <Input
                                                type="text"
                                                name="ean_cases_breadth"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={productAttributes.ean_cases ? productAttributes['ean_cases']['inner_breadth']: ""}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                     <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Height</Label>
                                            <Input
                                                type="text"
                                                name="ean_cases_height"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={productAttributes.ean_cases ? productAttributes['ean_cases']['inner_height']: ""}
                                                
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                 <Row form>
                                    
                                    <Col md={4}>
                                        
                                        <FormGroup>
                                            <Label for="mobile">Shelf Life (Months)</Label>
                                            <Input
                                                type="number"
                                                name="ean_each_length"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={productAttributes.shelf_life}                                                
                                                disabled

                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">MRSL (Percentage)</Label>
                                            <Input
                                                type="number"
                                                name="ean_each_breadth"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={productAttributes.mrsl}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                            
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>
                         <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Pricing Details</span> 
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="email">MRP</Label>
                                            <Input
                                                type="number"
                                                name="mrp"
                                                id="email"
                                                onChange={this.handleChange}
                                                value={productPricing.mrp}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Std Cost</Label>
                                            <Input
                                                type="number"
                                                name="std_cost"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={productPricing.std_cost}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                
                                
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Per Qty.</Label>
                                            <Input
                                                type="number"
                                                name="per_qty"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={productPricing.per_qty}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                   
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>

                         <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">UOM Details</span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="email">Purchase UOM</Label>
                                            <Input
                                                type="text"
                                                name="purchase_uom"
                                                id="email"
                                                onChange={this.handleChange}
                                                value={uomDetails.purchase_uom}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Std Purchase Price</Label>
                                            <Input
                                                type="text"
                                                name="std_purchase_price"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={uomDetails.std_purchase_price}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Sales UOM</Label>
                                            <Input
                                                type="text"
                                                name="sales_uom"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                value={uomDetails.sales_uom}
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                    {/*<Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Std Purchase Price</Label>
                                            <Input
                                                type="text"
                                                name="std_purchase_price"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>*/}
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>

                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Data History</span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label style={{color: '#777777', fontWeight: 'bold', fontSize: 13}} for="email">Created By</Label><br/>
                                            <span> {dataHistory ? dataHistory.created_by : ""}</span>
                                            
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label style={{color: '#777777', fontWeight: 'bold', fontSize: 13}} for="email">Created Date</Label><br/>
                                            <span> {dataHistory ? dataHistory.created_date_time : ""}</span>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                             <Label style={{color: '#777777', fontWeight: 'bold', fontSize: 13}} for="email">Last Modified By</Label><br/>
                                            <span> {dataHistory ? dataHistory.updated_by : ""}</span>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label style={{color: '#777777', fontWeight: 'bold', fontSize: 13}} for="email">Last Modified Date</Label><br/>
                                            <span> {dataHistory ? dataHistory.updated_date_time : ""}</span>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>
                    </Accordion>

                   

                <Modal isOpen={modalNew} backdrop="static" toggle={this.toggleNew}>
                  <div className="modal__header">
                    <button
                      className="lnr lnr-cross modal__close-btn"
                      type="button"
                      style={{ right: 15 }}
                      onClick={this.toggleNew}
                    />
                  </div>
                  <div
                    className="modal__body"
                    style={{ paddingTop: 55, paddingBottom: 20 }}
                  >
                    <span
                      className="lnr lnr-thumbs-up modal__title-icon"
                      style={{ color: "#4ce1b6" }}
                    />
                    <h3>{this.state.success_message} </h3>
                    
                  </div>
                  <ButtonToolbar className="modal__footer">
                    <Button
                      style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                      className="modal_ok"
                      onClick={this.toggleBack}
                    >
                      Ok
                    </Button>
                  </ButtonToolbar>
                </Modal>

                <Modal isOpen={failedModal} backdrop="static" toggle={this.Failedtoggle}>
                    <div className="modal__header">
                      <button
                        className="lnr lnr-cross modal__close-btn"
                        type="button"
                        style={{ right: 15 }}
                        onClick={this.Failedtoggle}
                      />
                    </div>
                    <div
                      className="modal__body"
                      style={{ paddingTop: 55, paddingBottom: 20 }}
                    >
                      <span
                        className="lnr lnr-cross-circle modal__title-icon"
                        style={{ color: "red" }}
                      />
                      <h4>{this.state.failed_message} </h4>
                    </div>
                    <ButtonToolbar className="modal__footer">
                      <Button
                        style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                        className="modal_ok"
                        onClick={this.Failedtoggle}
                      >
                        Ok
                      </Button>
                    </ButtonToolbar>
                </Modal>



              
            </div>
        );
    }
}

export default HorizontalForm;
